import React from 'react';
import GameScoreBoard from '../GameScoreBoard.js';
import {_GPY,__GPYPost} from '../../../env.js'

import GpyToggleButton from '../lib/GpyToggleButton.js';
import GpyTime from '../lib/GpyTime.js';
import GpyScoreButton from '../lib/GpyScoreButton.js';
import GpyScoreField from '../lib/GpyScoreField.js';
import GpyTeamSelect from '../lib/GpyTeamSelect.js'
import GpyGameLog from '../lib/GpyGameLog.js';
import GpyTeamList from '../lib/GpyTeamList.js';
import GpyPenaltyButton from '../lib/GpyPenaltyButton.js';

import WaitCube from '../../../WaitCube';

import ScoreboardGameSelector from '../lib/ScoreboardGameSelector.js';
import ScoreboardDisplayPanel from '../lib/ScoreboardDisplayPanel.js';
import ScoreboardFreeTextPanel from '../lib/ScoreboardFreeTextPanel.js';
import ScoreboardTeamScorePanel from '../lib/ScoreboardTeamScorePanel.js';
import ScoreboardAdvertisementTournament from '../lib/ScoreboardAdvertisementTournament.js';
import ScoreboardTeamDefaultButtons from '../lib/ScoreboardTeamDefaultButtons.js';
import ScoreboardPeriods from '../lib/ScoreboardPeriods.js';
import ScoreboardClock from '../lib/ScoreboardClock.js';
import ScoreboardStats from '../lib/ScoreboardStats.js';


class SBIceHockey extends GameScoreBoard {
	constructor(props) {
		super(props);
		var s = super.getGPYState("IceHockey");
		s.NAME = "IceHockey";
		this.state = s;
		s.currentSet = 0;
		s.defaultDataStore = {homeScore:0,guestScore:0};
		s.mainClockDependenciesClocks=[
			 {clock : this.getName()+"_powerplayHome", button : this.getName()+'_button_powerplay_home_2'},
			 {clock : this.getName()+"_powerplayHome", button : this.getName()+'_button_powerplay_home_22'},
			 {clock : this.getName()+"_powerplayHome", button : this.getName()+'_button_powerplay_home_5'},

			 {clock : this.getName()+"_powerplayGuest", button : this.getName()+'_button_powerplay_guest_2'},
			 {clock : this.getName()+"_powerplayGuest", button : this.getName()+'_button_powerplay_guest_22'},
			 {clock : this.getName()+"_powerplayGuest", button : this.getName()+'_button_powerplay_guest_5'},

			 {clock : this.getName()+"_powerplayHome2", button : this.getName()+'_button_powerplay2_home_2'},
			 {clock : this.getName()+"_powerplayHome2", button : this.getName()+'_button_powerplay2_home_22'},
			 {clock : this.getName()+"_powerplayHome2", button : this.getName()+'_button_powerplay2_home_5'},

			 {clock : this.getName()+"_powerplayGuest2", button : this.getName()+'_button_powerplay2_guest_2'},
			 {clock : this.getName()+"_powerplayGuest2", button : this.getName()+'_button_powerplay2_guest_22'},
			 {clock : this.getName()+"_powerplayGuest2", button : this.getName()+'_button_powerplay2_guest_5'},
		];
	}

	componentDidMount() {
		super.componentDidMount();
		super.loadUserConfig().then((res)=>{
			super.getGamesStates();
			super.getGames();
		});
	}
	componentWillUnmount() {
		 super.componentWillUnmount();
	}
	getMainClock() {
		return super.getMainClock();
	}
	togglePlay(method) {
		return super.togglePlay(method);
	}
	adjustTimers(millis,callback) {
		return super.adjustTimers(millis,callback) ;
	}
	initDataStore(id) {
		var ds = this.state.dataStore;
		this.setState({dataStore:ds});
	}
	getCurrentGuestScore() {
		return  this.state.dataStore.guest_score;;
	}
	getCurrentHomeScore() {
		return  this.state.dataStore.home_score;;
	}


	render () {
		const sponsorLogo = this.state.currentGame.sponsorLogo!==undefined&&this.state.currentGame.sponsorLogo!==''?this.state.currentGame.sponsorLogo:"empty.png";
		if(!this.state.defaultValuesLoaded) {
			return (<WaitCube/>);
		}

		return (
			<>
				 <GpyTime stateName={this.getName()+"_powerplayHome"} hidden="true" countdown="true" scoreboard={this}/>
			 	 <GpyTime stateName={this.getName()+"_powerplayGuest"} hidden="true" countdown="true" scoreboard={this}/>
			 	 <GpyTime stateName={this.getName()+"_powerplayHome2"} hidden="true" countdown="true" scoreboard={this}/>
			 	 <GpyTime stateName={this.getName()+"_powerplayGuest2"} hidden="true" countdown="true" scoreboard={this}/>

					<ScoreboardGameSelector scoreboard={this} beta={true}/>

	{this.state.currentGame.id > 0 ?

					<div className="row p-3">
					 <div className="col" style={{maxWidth:this.state.displayWidth+"px"}}>

								<ScoreboardDisplayPanel scoreboard={this} />

								<div className="row"><div className="col-12">
										<ScoreboardTeamScorePanel scoreboard={this}
										 onChangeHomeScore={(score,callback)=>{
											var ds = this.state.dataStore;
											ds.home_score = score;
											this.setState({dataStore:ds},()=>{
												super.storeData();
												callback();
											});
										}}
										onChangeGuestScore={(score,callback)=>{
											var ds = this.state.dataStore;
											ds.guest_score = score;
											this.setState({dataStore:ds},()=>{
												super.storeData();
												callback();
											});
										}}
										getUpdateDependenciesComponents={()=>{
											return [
												this.getName() + "_button_vs_and_score_full",
												this.getName() + "_button_vs_and_score_mini"
											];
										}}
										/>
								</div></div>


								<div className="row"><div className="col-12"><ScoreboardFreeTextPanel scoreboard={this} credits={true}/></div></div>
								<div className="row"><div className="col-12" style={{height:"300px",overflowY: "scroll"}}>
										<GpyGameLog stateName="gamelog" scoreboard={this} game={this.state.currentGame} onLoad={ (log) => {}}/>
								</div></div>

					 </div>
					 <div className="col-sm col-md col-lg col-xl">
								<div className="row">
										<div className="col-sm-12 col-md-12 col-lg-6 col-xl-6">

											<ScoreboardPeriods scoreboard={this} periodCount={5}
											getUpdateDependenciesComponents={()=>{
												return [
													this.getName() + "_button_vs_and_score_full",
													this.getName() + "_button_vs_and_score_mini",
													this.getName() + "_button_full_statistics"
												];
											}}
											/>
											<ScoreboardTeamDefaultButtons scoreboard={this}
													getOnDeactiveSmallDependenciesComponents={()=>{
														return [
															this.getName() + "_button_show_period"
														];
													}}

											/>

											<div className="row">
											<div className="col-12 p-1"><strong>{_GPY.i18n.get('gametype_'+this.getName()+'_scoreboard_penalty_header')}</strong></div>

											<div className="col-3 p-1">
												 <GpyToggleButton title={_GPY.i18n.get('gametype_'+this.getName()+'_scoreboard_penalty_button_2')}
												        condition={() => {return (this.playerCountByRole("HOME_TEAM_PLAYER,GUEST_TEAM_PLAYER,HOME_TEAM_SUBSTITUE,GUEST_TEAM_SUBSTITUE")===1)}}
																onInit={() => {return {}}}
																onDeactivate={() => {
																	return {visible: false}}}
																onActivate={() => {
																	var p = super.getHomeOrGuestPlayer();
																	var res ={visible: true, type:"Penalty2",
																		player: p,
																		team: super.getTeamByPlayer(p),
																		message: _GPY.i18n.get('gametype_'+this.getName()+'_scoreboard_penalty_message_2')};
																		return res;
																}}
																autoexpirytime="8"
																scoreboard={this}
																getTime={()=>this.getCurrentMainTime()} getGameId={()=>this.getCurrentGameId()}
															 	stateName={this.getName()+"_button_penalty_2"}
													/>
											 </div>

												<div className="col-3 p-1">
														<GpyToggleButton title={_GPY.i18n.get('gametype_'+this.getName()+'_scoreboard_penalty_button_22')}
														  condition={() => {return (this.playerCountByRole("HOME_TEAM_PLAYER,GUEST_TEAM_PLAYER,HOME_TEAM_SUBSTITUE,GUEST_TEAM_SUBSTITUE")===1)}}
														 	onInit={() => {return {}}}
	 														onDeactivate={() => {
	 															return {visible: false}}}
	 														onActivate={() => {
	 															var p = super.getHomeOrGuestPlayer();
	 															var res ={visible: true, type:"Penalty22",
	 																player: p,
	 																team: super.getTeamByPlayer(p),
	 																message: _GPY.i18n.get('gametype_'+this.getName()+'_scoreboard_penalty_message_22')};
	 																return res;
	 														}}
														 scoreboard={this}
														 getTime={()=>this.getCurrentMainTime()} getGameId={()=>this.getCurrentGameId()}
														 stateName={this.getName()+"_button_penalty_22"}
														 autoexpirytime="8"/>
												</div>

												<div className="col-3 p-1">
														<GpyToggleButton title={_GPY.i18n.get('gametype_'+this.getName()+'_scoreboard_penalty_button_5')}
															 condition={() => {return (this.playerCountByRole("HOME_TEAM_PLAYER,GUEST_TEAM_PLAYER,HOME_TEAM_SUBSTITUE,GUEST_TEAM_SUBSTITUE")===1)}}
															 title={_GPY.i18n.get('gametype_'+this.getName()+'_scoreboard_penalty_button_5')}
															 onInit={() => {return {}}}
															 onDeactivate={() => {
																 return {visible: false}}}
															 onActivate={() => {
																 var p = super.getHomeOrGuestPlayer();
																 var res ={visible: true, type:"Penalty5",
																	 player: p,
																	 team: super.getTeamByPlayer(p),
																	 message: _GPY.i18n.get('gametype_'+this.getName()+'_scoreboard_penalty_message_5')};
																	 return res;
															 }}
															 scoreboard={this}
															 getTime={()=>this.getCurrentMainTime()} getGameId={()=>this.getCurrentGameId()}
															 stateName={this.getName()+"_button_penalty_5"}
															 autoexpirytime="8"/>
													</div>

													<div className="col-3 p-1">
															<GpyToggleButton title={_GPY.i18n.get('gametype_'+this.getName()+'_scoreboard_penalty_button_10')}
																 condition={() => {return (this.playerCountByRole("HOME_TEAM_PLAYER,GUEST_TEAM_PLAYER,HOME_TEAM_SUBSTITUE,GUEST_TEAM_SUBSTITUE")===1)}}
																 title={_GPY.i18n.get('gametype_'+this.getName()+'_scoreboard_penalty_button_10')}
																 onInit={() => {return {}}}
																 onDeactivate={() => {
																	 return {visible: false}}}
																 onActivate={() => {
																	 var p = super.getHomeOrGuestPlayer();
																	 var res ={visible: true, type:"Penalty10",
																		 player: p,
																		 team: super.getTeamByPlayer(p),
																		 message: _GPY.i18n.get('gametype_'+this.getName()+'_scoreboard_penalty_message_10')};
																		 return res;
																 }}
																 scoreboard={this}
																 getTime={()=>this.getCurrentMainTime()} getGameId={()=>this.getCurrentGameId()}
																 stateName={this.getName()+"_button_penalty_10"}
																 autoexpirytime="8"/>
													</div>

											</div>







											<div className="row">
												<div className="col-12 p-1"><strong>{_GPY.i18n.get('gametype_'+this.getName()+'_scoreboard_powerplay_header')}</strong></div>
												<div className="col-2 p-1"><GpyPenaltyButton scoreboard={this} name="powerplay_home_2" clockName="powerplayHome" countDownTime={(2*60*1000)} repeat={0}/></div>
												<div className="col-2 p-1"><GpyPenaltyButton scoreboard={this} name="powerplay_home_22" clockName="powerplayHome" countDownTime={(2*60*1000)} repeat={1}/></div>
												<div className="col-2 p-1"><GpyPenaltyButton scoreboard={this} name="powerplay_home_5" clockName="powerplayHome" countDownTime={(5*60*1000)} repeat={0}/></div>

												<div className="col-2 p-1"><GpyPenaltyButton scoreboard={this} name="powerplay_guest_2" clockName="powerplayGuest" countDownTime={(2*60*1000)} repeat={0}/></div>
												<div className="col-2 p-1"><GpyPenaltyButton scoreboard={this} name="powerplay_guest_22" clockName="powerplayGuest" countDownTime={(2*60*1000)} repeat={1}/></div>
												<div className="col-2 p-1"><GpyPenaltyButton scoreboard={this} name="powerplay_guest_5" clockName="powerplayGuest" countDownTime={(5*60*1000)} repeat={0}/></div>
											</div>

											<div className="row">
												<div className="col-2 p-1"><GpyPenaltyButton scoreboard={this} name="powerplay2_home_2" clockName="powerplayHome2" countDownTime={(2*60*1000)} repeat={0}/></div>
												<div className="col-2 p-1"><GpyPenaltyButton scoreboard={this} name="powerplay2_home_22" clockName="powerplayHome2" countDownTime={(2*60*1000)} repeat={1}/></div>
												<div className="col-2 p-1"><GpyPenaltyButton scoreboard={this} name="powerplay2_home_5" clockName="powerplayHome2" countDownTime={(5*60*1000)} repeat={0}/></div>

												<div className="col-2 p-1"><GpyPenaltyButton scoreboard={this} name="powerplay2_guest_2" clockName="powerplayGuest2" countDownTime={(2*60*1000)} repeat={0}/></div>
												<div className="col-2 p-1"><GpyPenaltyButton scoreboard={this} name="powerplay2_guest_22" clockName="powerplayGuest2" countDownTime={(2*60*1000)} repeat={1}/></div>
												<div className="col-2 p-1"><GpyPenaltyButton scoreboard={this} name="powerplay2_guest_5" clockName="powerplayGuest2" countDownTime={(5*60*1000)} repeat={0}/></div>
											</div>

											<div className="row">

											<div className="col-6 p-1">
												<GpyToggleButton
														title="Powerbreak"
														onInit={() => {return {}}}
														onDeactivate={() => {
															super.onPlayTime(this.getName()+"_countdown","stop");
															return {visible: false}}}
															onActivate={() => {
															super.startTimeAt(this.getName()+"_countdown",(30*1000));
															return {visible: true,type:"Powerplay",
																message: _GPY.i18n.get('gametype_'+this.getName()+'_scoreboard_message_powerbreak')}}}
														autoexpirytime="30" warnOnly="false"
														scoreboard={this}
														getTime={()=>this.getCurrentMainTime()} getGameId={()=>this.getCurrentGameId()}
														stateName={this.getName()+"_button_power_break"}
														/>
											</div>
											<div className="col-6 p-1">
												<GpyToggleButton
														title="Ice Cleaning"
														onInit={() => {return {}}}
														onDeactivate={() => {return {visible: false}}}
														onActivate={() => {
															 super.startTimeAt(this.getName()+"_countdown",(45*1000));
															 return {visible: true,type:"IceCleaning",
															 message: _GPY.i18n.get('gametype_'+this.getName()+'_scoreboard_message_ice_cleaning')}}}
														autoexpirytime="45" warnOnly="false"
														scoreboard={this}
														getTime={()=>this.getCurrentMainTime()} getGameId={()=>this.getCurrentGameId()}
														stateName={this.getName()+"_button_ice_cleaning"}
														/>
											</div>




											</div>




											<ScoreboardStats scoreboard={this}/>
											<ScoreboardClock scoreboard={this} startStopKeyCode=" " togglePlay={(e)=>this.togglePlay(e)} countdown={true}
													defaultTimes={[{name:"20:00",time:(((20*60))*1000)},{name:"40:00",time:(40*60*1000)},{name:"60:00",time:(60*60*1000)}]}
													adjustButtons={[{name:"-5",time:-5000},{name:"-2",time:-2000},{name:"-1",time:-1000},{name:"+1",time: 1000},{name:"+2",time:2000},{name:"+5",time:5000}]}
											/>
											<ScoreboardClock scoreboard={this} startStopKeyCode=","  withOverlayButton={true}  clockName="countdown" countdown={true}  defaultTimes={[{name:"20:00",time:(((20*60))*1000)},{name:"15:00",time:(15*60*1000)},{name:"10:00",time:(10*60*1000)},{name:"05:00",time:(5*60*1000)}]}/>
											<ScoreboardAdvertisementTournament scoreboard={this}/>
										</div>
										<div className="col-sm-12 col-md-12 col-lg-6 col-xl-6">
														<div className="row">
															<div className="col-6">
																	<strong>{_GPY.i18n.get('gametype_'+this.getName()+'_scoreboard_playerlist_home_title')}</strong>
																	<GpyTeamList scoreboard={this} exclusionRoles="HOME_TEAM_SUBSTITUE" game={this.state.currentGame} vsRole="HOME_TEAM_PLAYER" stateName={this.getName()+"_teamlist_home_player"}/>
															 </div>
															 <div className="col-6">
																	<strong>{_GPY.i18n.get('gametype_'+this.getName()+'_scoreboard_playerlist_guest_title')}</strong>
																	<GpyTeamList scoreboard={this} exclusionRoles="GUEST_TEAM_SUBSTITUE" game={this.state.currentGame} vsRole="GUEST_TEAM_PLAYER" stateName={this.getName()+"_teamlist_guest_player"}/>
															 </div>
														</div>
														<div className="row">
															<div className="col-12"><strong>{_GPY.i18n.get('gametype_'+this.getName()+'_scoreboard_playerlist_substitue_title')}</strong></div>
															<div className="col-6"><GpyTeamList scoreboard={this} color="warning" exclusionRoles="HOME_TEAM_PLAYER"  game={this.state.currentGame} vsRole="HOME_TEAM_SUBSTITUE" stateName={this.getName()+"_teamlist_home_substitue"}/></div>
															<div className="col-6"><GpyTeamList scoreboard={this} color="warning" exclusionRoles="GUEST_TEAM_PLAYER" game={this.state.currentGame} vsRole="GUEST_TEAM_SUBSTITUE" stateName={this.getName()+"Hockey_teamlist_guest_substitue"}/></div>
														</div>
														<div className="row">
															<div className="col-12"><strong>{_GPY.i18n.get('gametype_'+this.getName()+'_scoreboard_playerlist_coach_title')}</strong></div>
															<div className="col-6"><GpyTeamList scoreboard={this} color="secondary"  exclusionRoles="GUEST_TEAM_COACH" game={this.state.currentGame} vsRole="HOME_TEAM_COACH" stateName={this.getName()+"_teamlist_home_coach"}/></div>
															<div className="col-6"><GpyTeamList scoreboard={this} color="secondary"  exclusionRoles="HOME_TEAM_COACH" game={this.state.currentGame} vsRole="GUEST_TEAM_COACH" stateName={this.getName()+"_teamlist_guest_coach"}/></div>
														</div>
										</div>

								</div>
						 </div>
					</div>

 :<div>{_GPY.i18n.get('gametype_'+this.getName()+'_scoreboard_warn_message_selectgame')}</div>}
		</>
	 )
	}

}
export default SBIceHockey;
